<div class="title" #title>
  <div class="container container-max-width">
    <h1 class="h4">Query from All Requests</h1>
    <p style="line-height: 20px">
      <br />
    </p>
  </div>
</div>

<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main">
    <form #inputForm="ngForm" autocomplete="off" novalidate>
      <div class="form-group">
        <label id="region-label" for="region" class="form-label"><strong>Regions:</strong></label>
        <ng-select [(ngModel)]="regions" [items]="regionList" [multiple]="true" name="region" labelForId="region" [inputAttrs]="{ 'aria-labelledby': 'region-label' }"></ng-select>
      </div>
      <div class="form-group">
        <label id="requestor-label" for="requestor" class="form-label"><strong>Requestors:</strong></label>
        <ng-select
          [(ngModel)]="requestors"
          [items]="requestorList"
          [multiple]="true"
          name="requestor"
          labelForId="requestor"
          [inputAttrs]="{ 'aria-labelledby': 'requestor-label' }"
          groupBy="ring"
          [virtualScroll]="true">
        </ng-select>
        <div>
          <label>
            <input type="checkbox" [(ngModel)]="other" name="Other" />
            <span class="ms-1">Other Requestor</span>
          </label>
          <input *ngIf='other === true' class="form-control" [(ngModel)]="otherRequestor" name="otherRequestor" aria-label="Other requestor" placeholder="Type your requestor" />
        </div>
      </div>
      <div class="form-group">
        <label for="submitter" class="form-label"><strong>Submitter:</strong></label>
        <input class="form-control" [(ngModel)]="submitter" name="submitter" id="submitter" aria-label="Submitter" />
      </div>
      <div class="form-group">
        <label for="sub" class="form-label"><strong>Subscription ID:</strong></label>
        <input class="form-control" [(ngModel)]="sub" name="sub" id="sub" aria-label="Subscription ID" />
      </div>
      <div class="form-group nofloat">
        <button type="submit" class="btn btn-primary me-1" [disabled]="submitDisabled" (click)="submitRequest()">
          Submit
        </button>
      </div>
      <div class="info-box">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span class="ms-1">Please provide at least one.</span>
      </div>
      <hr />
    </form>
    <div>
      <button class="sbutton mb-3" title="Export current results" (click)="export()">Export</button>
      <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
      <ag-grid-angular
        style="height: 540px"
        class="ag-theme-balham"
        [gridOptions]="gridOptions"
        [rowData]="subRequestsWithTickets"
        (gridReady)="onGridReady($event)"
        [pagination]="true"
      >
      </ag-grid-angular>
    </div>
    <hr />
  </div>
</div>
